export default {"src":"/_next/static/media/document.dbe3697e.svg","height":75,"width":76};